/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
import { ActionButton, FontSizes, FontWeights, IconButton, Link } from "@fluentui/react";
import React from "react";
import { IConfiguration, ILocation } from "./interfaces";
import { theme } from "./Module";

interface ILocationsProps {
    loadNav: (siteId: string, docName: string, path: string) => void;
}

interface IlocationsState {
    locations: ILocation[];
    recents: ILocation[];
}

export class Locations extends React.Component<ILocationsProps, IlocationsState> {
    protected obj: IConfiguration = { locations: [], recents: [] };
    constructor(props: ILocationsProps) {
        super(props);
        this.state = { locations: [], recents: [] };
    }
    componentDidMount(): void {
        if (localStorage.getItem('outConfig') !== null) {
            this.obj = JSON.parse(localStorage.getItem('outConfig'));
            this.setState({ locations: this.obj.locations, recents: this.obj.recents });
        }
    }
    private locations = (item: ILocation) => {
        return (<div style={{ paddingBottom: 5 }}>
            <div style={{ display: 'table' }}><ActionButton onClick={() => {
                this.props.loadNav(item.siteid, item.listid, item.path);
            }} iconProps={{ iconName: 'Save' }} styles={{ root: { display: 'table-cell', verticalAlign: 'middle', fontWeight: FontWeights.semibold, fontSize: FontSizes.smallPlus, color: theme.palette.neutralSecondary } }} title='Click to save to this location' defaultChecked={true}>{item.title}</ActionButton> <IconButton iconProps={{ iconName: 'Delete', }} styles={{ root: { display: 'table-cell', verticalAlign: 'middle' } }} title="Delete this pinned location" aria-label="Emoji" disabled={false}
                onClick={() => { this.removeItem(item.path); }} /> </div>
            <div > <Link styles={{ root: { fontSize: FontSizes.small, color: theme.palette.blackTranslucent40, textWrap: 'pretty' } }} title={item.path} href={item.path}><div style={{ width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.path}</div></Link></div>

        </div>

        );
    };
    private removeItem(path: string): void {
        let conf: IConfiguration = { locations: [], recents: [] };

        conf = JSON.parse(localStorage.getItem('outConfig'));
        conf.locations = conf.locations.filter(x => x.path !== path);
        localStorage.setItem('outConfig', JSON.stringify(conf));
        this.setState({ locations: conf.locations });

    }
    private recents = (item: ILocation) => {
        return (<div style={{ paddingBottom: 5 }}>
            <div style={{ display: 'table' }}> <ActionButton onClick={() => {
                this.props.loadNav(item.siteid, item.listid, item.path);
            }} iconProps={{ iconName: 'Save' }} styles={{ root: { display: 'table-cell', verticalAlign: 'middle', fontWeight: FontWeights.semibold, fontSize: FontSizes.smallPlus, color: theme.palette.neutralSecondary } }} title='Click to save to this location' defaultChecked={true}>{item.title}</ActionButton><span style={{ fontSize: FontSizes.small, fontStyle: 'italic' }}> {item.saved !== undefined ? item.saved : ''}</span></div>
            <div > <Link styles={{ root: { fontSize: FontSizes.small, color: theme.palette.blackTranslucent40, textWrap: 'pretty' } }} title={item.path} href={item.path}><div style={{ width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.path}</div></Link></div>

        </div>

        );
    };
    public render(): JSX.Element {

        return <React.Fragment>
            <div>
                <div style={{ fontWeight: FontWeights.semibold, color: theme.palette.neutralPrimary, borderBottom: '1px inset ' + theme.palette.blackTranslucent40, paddingBottom: 5, paddingTop: 10, marginBottom: 10 }}>Pinned Locations</div>
                {this.state !== null && this.state.locations !== undefined && this.state.locations.filter(x => x.title !== undefined && x.title.length > 1).map(this.locations)}
            </div>
            <div style={{ paddingTop: 20 }}>
                <div style={{ fontWeight: FontWeights.semibold, color: theme.palette.neutralPrimary, borderBottom: '1px inset ' + theme.palette.blackTranslucent40, paddingBottom: 5, paddingTop: 10, marginBottom: 10 }}>Recent Locations</div>
                {this.state !== null && this.state.recents !== undefined && this.state.recents.map(this.recents)}
            </div>
        </React.Fragment>;
    }
}
